export function paymentQuery(search) {
  const params = new URLSearchParams(search)
  const filters = {}
  for (const key of ["type", "paymentType", "status", "currency", "startDate", "endDate", "search"]) {
    if (params.get(key)) filters[key] = params.get(key).trim()
  }
  const page = Number(params.get("page")), limit = Number(params.get("limit"))
  return { filters, options: { page: Number.isSafeInteger(page) && page > 0 ? page : 1,
    limit: Number.isSafeInteger(limit) && limit > 0 && limit <= 100 ? limit : 25,
    sortBy: params.get("sortBy") || "recordedAt:desc" } }
}
